import { Pipe, PipeTransform } from "@angular/core";
import * as moment from 'moment';
import { LocaleService } from "../services/locale/locale-service";

@Pipe({
  name: 'timeDistance'
})
export class TimeDistancePipe implements PipeTransform {
  constructor(private localeService: LocaleService) { }
  transform(datetime: string) {
    moment.locale('ko');
    const currentTime = new Date(moment().format());
    const target = new Date(datetime);
    return this.getFormatTimeDistance(target, currentTime);
  }

  // 현재시간 대비 거리
  private getFormatTimeDistance(target: Date, current: Date) {
    const offset = current.getTime() - target.getTime();
    if (offset < 0) {
      return this.localeService.getLocaleString(`방금`);
    } else if (offset < 60000) {
      return `${Math.floor(offset / 1000)}${this.localeService.getLocaleString('초')} ${this.localeService.getLocaleString('전')}`;
    } else if (offset < 3600000) {
      return `${Math.floor(offset / 60000)}${this.localeService.getLocaleString('분')} ${this.localeService.getLocaleString('전')}`;
    } else if (offset < 86400000) {
      return `${Math.floor(offset / 3600000)}${this.localeService.getLocaleString('시간')} ${this.localeService.getLocaleString('전')}`;
    } else if (offset < 86400000 * 7) {
      return `${Math.floor(offset / 86400000)}${this.localeService.getLocaleString('일')} ${this.localeService.getLocaleString('전')}`;
    } else {
      if (target.getFullYear() !== current.getFullYear()) {
        if (this.localeService.isKo) {
          return `${target.getFullYear()}년 ${this.getDate(target)}`;
        }
        return `${target.getFullYear()} / ${this.getDate(target)}`;
      } else {
        return this.getDate(target);
      }
    }
  }

  /**
   * date 형태의 시간 가져오기
   * ex. '9월 30일'
   */
  getDate(target: Date): string {
    if (this.localeService.isKo) {
      return `${target.getMonth() + 1}월 ${target.getDate()}일`;

    }
    return `${target.getMonth() + 1} / ${target.getDate()}`;
  }
}